import { useEffect } from "react";
import SelectLayerDropdown from "../controls/selectLayerDropdown";
import store from "../../stores/store";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import SelectAttributesDropdown from "../controls/selectAttributesDropdrown";
import {
  createNotification,
  fetch,
  fetchAsync,
  key,
  searchLayerRequest,
  trans,
} from "../../lib/utils";
import {
  FeatureToGeoJSON,
  GeoJSONToWKT,
  WKTtoGeoJSON,
  filterFeatureRecordFromAttribute,
  filterGeoJSONFromAttribute,
  formatSearchResultsFromServiceResponse,
  getGeoJSONData,
  showFeature,
} from "../../lib/featureUtils";
import FeaturesTable from "../controls/featuresTable";
import SelectFeaturesFromUploadFile from "../controls/selectFeaturesFromUploadFile";
import { cloneDeep } from "lodash";
import {
  draw,
  getLayerById,
  setLayerCQL,
  setLayerParams,
} from "../map/mapUtils";
import BootstrapTable from "react-bootstrap-table-next";
import { useState } from "react";
import { intersect, polygon } from "@turf/turf";

function CQLFilterPanel() {
  const groups = useSelector((state) => store.getState().cqlFilter.groups);
  const selectedLayer = useSelector(
    (state) => store.getState().cqlFilter.layer
  );

  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const favorites = useSelector(
    (state) => store.getState().results.favoriteResults
  );

  useEffect(() => {}, []);

  const fetchSpatialResults = (
    layerId,
    group,
    criteria,
    groupIndex,
    criteriaIndex
  ) => {
    store.dispatch({
      type: "cqlFilter/criteria/update",
      payload: {
        groupIndex: groupIndex,
        criteriaIndex: criteriaIndex,
        property: "searchData",
        value: "pending",
      },
    });

    const layer = layers[layerId];

    const source = sources[layer.source.id];

    if (source.type === "GEOJSON") {
      let data = filterGeoJSONFromAttribute(
        JSON.parse(source.url),
        criteria["attribute"],
        criteria["attributeOperator"] ? criteria["attributeOperator"] : "=",
        criteria["attributeValue"]
      );

      store.dispatch({
        type: "cqlFilter/criteria/update",
        payload: {
          groupIndex: groupIndex,
          criteriaIndex: criteriaIndex,
          property: "searchData",
          value: data,
        },
      });
    } else {
      let cql = criteria["attribute"].concat(
        " ",
        criteria["attributeOperator"] ? criteria["attributeOperator"] : "=",
        " ",
        criteria["attributeValue"]
      );

      fetch(
        window["appConfig"]()["api"](),
        "POST",
        {},
        [searchLayerRequest(layer, source, cql, null)],
        (resp) => {
          let data = formatSearchResultsFromServiceResponse(resp);

          store.dispatch({
            type: "cqlFilter/criteria/update",
            payload: {
              groupIndex: groupIndex,
              criteriaIndex: criteriaIndex,
              property: "searchData",
              value: data,
            },
          });
        }
      );
    }
  };

  const updateSelectedFeatures = (
    selected,
    group,
    criteria,
    groupIndex,
    criteriaIndex
  ) => {
    let selectedFiltered = criteria["selected"]
      ? [...criteria["selected"]]
      : [];

    if (Array.isArray(selected)) {
      selectedFiltered = [...selected];
    } else {
      let selectedExistIndex = null;

      selectedFiltered?.forEach((el, idx) => {
        if (selected._featureId === el._featureId) {
          selectedExistIndex = idx;
        }
      });

      if (selectedExistIndex !== null) {
        selectedFiltered.splice(selectedExistIndex, 1);
      } else {
        selectedFiltered.push(selected);
      }
    }

    store.dispatch({
      type: "cqlFilter/criteria/update",
      payload: {
        groupIndex: groupIndex,
        criteriaIndex: criteriaIndex,
        property: "selected",
        value: selectedFiltered,
      },
    });
  };

  const getSelectedFeatures = async (features, toProjection) => {
    let url = "";
    let fromProjection = "";
    const selected = features?.map((feature) => {
      if (feature._featureUrl) {
        fromProjection = feature._srsName;
        url = feature._featureUrl;
        return feature._featureId;
      }
    });

    url = url.concat(",", selected.join(","));

    let featureGeometries = [];

    await fetchAsync(
      window["appConfig"]()["api"](
        "?proxy=getfeatures&method=get&url=".concat(url)
      ),
      "POST",
      {},
      []
    ).then((resp) => {
      resp?.data?.features?.forEach((feature) => {
        featureGeometries.push(
          GeoJSONToWKT(feature, fromProjection, toProjection)
        );
      });
    });

    return featureGeometries;
  };

  const search = async () => {
    let searchLayer = {};

    let searchKey = key();

    if (selectedLayer) {
      searchLayer[selectedLayer] = {};
    } else {
      searchLayer = { ...layers };
    }

    let drawedFeatures = [];
    let searchCompletedQueue = Object.keys(searchLayer);
    let selectedFeaturesWKT = [];
    let attributesCriteria = [];

    for (var layer in searchLayer) {
      const currentLayer = layers[layer];

      let cqlFilter = [];

      for (var i = 0; i < groups.length; i++) {
        let group = groups[i];
        let groupOperator = group[0]["operator"];

        let groupCQLFilter = [];

        for (var c = 1; c < group.length; c++) {
          let criteria = group[c];

          switch (criteria.type) {
            case "spatial":
              let spatialCQLFilter = [];
              if (criteria.spatialType === "draw") {
                criteria["selected"]?.forEach((feature) => {
                  let spatialOperator = criteria["spatialOperator"]
                    ? criteria["spatialOperator"]
                    : "INTERSECTS";

                  let wkt = GeoJSONToWKT(
                    feature._feature,
                    feature._feature.projection,
                    currentLayer.nativeProjection
                  );

                  selectedFeaturesWKT.push(wkt);

                  let cql = spatialOperator.concat(
                    "(",
                    currentLayer.geometryField,
                    ",",
                    wkt,
                    ")"
                  );
                  spatialCQLFilter.push(cql);

                  drawedFeatures.push(feature);
                });
              } else {
                let selectedFeatures = await getSelectedFeatures(
                  criteria["selected"],
                  currentLayer.nativeProjection
                );

                selectedFeatures.forEach((wkt) => {
                  let spatialOperator = criteria["spatialOperator"]
                    ? criteria["spatialOperator"]
                    : "INTERSECTS";

                  selectedFeaturesWKT.push(wkt);

                  let cql = spatialOperator.concat(
                    "(",
                    currentLayer.geometryField,
                    ",",
                    wkt,
                    ")"
                  );
                  spatialCQLFilter.push(cql);
                });
              }
              groupCQLFilter.push(
                "(".concat(spatialCQLFilter.join(" OR "), ")")
              );
              break;

            case "attributes":
              let cql = criteria["attribute"].concat(
                " ",
                criteria["attributeOperator"]
                  ? criteria["attributeOperator"]
                  : "=",
                " ",
                criteria["attributeValue"]
              );

              attributesCriteria.push({
                attribute: criteria["attribute"],
                operator: criteria["attributeOperator"]
                  ? criteria["attributeOperator"]
                  : "=",
                value: criteria["attributeValue"],
              });

              groupCQLFilter.push(cql);
              break;
          }
        }

        cqlFilter.push(groupCQLFilter.join(" " + groupOperator + " "));

        if (group.length === 1) {
          cqlFilter.push(" " + groupOperator + " ");
        } else {
          cqlFilter.push(" AND ");
        }
      }

      cqlFilter.pop();

      if (currentLayer?.source?.type === "GEOJSON") {
        let resultsData = [];

        let geoJSONFeatures = JSON.parse(sources[currentLayer.source.id].url);

        if (attributesCriteria.length > 0) {
          let geoJSONFeaturesData = getGeoJSONData(geoJSONFeatures);

          let filteredFeatureRecords = [];

          attributesCriteria?.forEach((el) => {
            geoJSONFeaturesData?.forEach((record) => {
              let filtered = filterFeatureRecordFromAttribute(
                record,
                el.attribute,
                el.operator,
                el.value
              );
              if (filtered) {
                filteredFeatureRecords.push(filtered);
              }
            });
          });

          filteredFeatureRecords?.forEach((record, featureIndex) => {
            selectedFeaturesWKT.forEach((wktFeature) => {
              const comparedFeature = WKTtoGeoJSON(wktFeature);

              if (intersect(JSON.parse(record._feature), comparedFeature)) {
                resultsData.push(record);
              }
            });
          });

          if (resultsData.length < 1 && selectedFeaturesWKT.length < 1) {
            resultsData = filteredFeatureRecords;
          }
        } else {
          geoJSONFeatures.features?.forEach((feature, featureIndex) => {
            selectedFeaturesWKT.forEach((wktFeature) => {
              const comparedFeature = WKTtoGeoJSON(wktFeature);

              if (intersect(feature, comparedFeature)) {
                resultsData.push({ ...feature.properties });
              }
            });
          });
        }

        resultsData.forEach((feature) => {});
      } else {
        store.dispatch({
          type: "cqlFilter/layer/add",
          payload: {
            id: currentLayer.id,
            cqlFilter: cqlFilter.join(" "),
            groups: groups,
          },
        });

        setLayerCQL(currentLayer, cqlFilter.join(" "));
      }
    }
  };

  const drawFeature = (type, group, criteria, groupIndex, criteriaIndex) => {
    draw(type, function (e) {
      let _featureId = key();
      e.feature.setId(_featureId);

      let _feature = FeatureToGeoJSON(e.feature);
      _feature.projection = window["map"].getView().getProjection().getCode();

      let feature = {
        _featureId: _featureId,
        _feature: _feature,
        type: type,
        wkt: GeoJSONToWKT(_feature, _feature.projection, _feature.projection),
      };

      store.dispatch({
        type: "cqlFilter/criteria/update",
        payload: {
          groupIndex: groupIndex,
          criteriaIndex: criteriaIndex,
          property: "selected",
          value: [
            ...(criteria["selected"] ? criteria["selected"] : []),
            feature,
          ],
        },
      });
    });
  };

  const spatialContent = (criteria, group, groupIndex, criteriaIndex) => {
    switch (criteria["spatialType"]) {
      case "draw":
        return (
          <>
            <div className="mt-2">
              <button
                type="button"
                className={"btn btn-sm small border me-1 "}
                data-bs-toggle="button"
                onClick={(e) => {
                  drawFeature(
                    "Polygon",
                    group,
                    criteria,
                    groupIndex,
                    criteriaIndex
                  );
                }}
              >
                <i className="fas fa-draw-polygon me-2"></i>
                {trans("Polygon")}
              </button>
              <button
                type="button"
                className={"btn btn-sm small border me-1 "}
                data-bs-toggle="button"
                onClick={(e) => {
                  drawFeature(
                    "LineString",
                    group,
                    criteria,
                    groupIndex,
                    criteriaIndex
                  );
                }}
              >
                <i className="fas fa-draw-polygon me-2"></i>
                {trans("Line")}
              </button>
              <button
                type="button"
                className={"btn btn-sm small border me-1 "}
                data-bs-toggle="button"
                onClick={(e) => {
                  drawFeature(
                    "Circle",
                    group,
                    criteria,
                    groupIndex,
                    criteriaIndex
                  );
                }}
              >
                <i className="far fa-circle me-2"></i>
                {trans("Circle")}
              </button>
              <button
                type="button"
                className={"btn btn-sm small border me-1 "}
                data-bs-toggle="button"
                onClick={(e) => {
                  criteria["selected"]?.forEach((el) => {
                    window["drawSource"].removeFeature(
                      window["drawSource"].getFeatureById(el._featureId)
                    );
                  });
                }}
              >
                <i className="fas fa-eraser me-2"></i>
                {trans("Clear")}
              </button>
            </div>

            {criteria["selected"]?.length > 0 ? (
              <>
                <div className="mt-2">
                  <BootstrapTable
                    key={key()}
                    keyField="_featureId"
                    data={criteria["selected"] ? criteria["selected"] : []}
                    columns={[
                      {
                        dataField: "_featureId",
                        text: "",
                        hidden: true,
                      },
                      {
                        dataField: "_feature",
                        text: "",
                        hidden: true,
                      },
                      {
                        dataField: "deleteFeature",
                        headerStyle: (colum, colIndex) => {
                          return { width: "30px", textAlign: "center" };
                        },
                        formatter: function (cell, row) {
                          return (
                            <i
                              className="fas fa-trash-alt  m-auto"
                              role="button"
                              onClick={(e) => {
                                let newSelected = [];

                                criteria["selected"]?.forEach((el) => {
                                  if (row._featureId !== el._featureId) {
                                    newSelected.push(el);
                                  }
                                });

                                window["drawSource"].removeFeature(
                                  window["drawSource"].getFeatureById(
                                    row._featureId
                                  )
                                );

                                store.dispatch({
                                  type: "cqlFilter/criteria/update",
                                  payload: {
                                    groupIndex: groupIndex,
                                    criteriaIndex: criteriaIndex,
                                    property: "selected",
                                    value: [...newSelected],
                                  },
                                });
                              }}
                            ></i>
                          );
                        },
                      },
                      {
                        dataField: "_zoomToFeature",
                        headerStyle: (colum, colIndex) => {
                          return { width: "30px", textAlign: "center" };
                        },
                        formatter: function (cell, row) {
                          return (
                            <i
                              className="fas fa-compress  m-auto"
                              role="button"
                              onClick={(e) => {
                                showFeature(row._feature);
                              }}
                            ></i>
                          );
                        },
                      },
                      {
                        dataField: "type",
                        text: "Draw Type",
                      },
                    ]}
                    wrapperClasses="bg-white"
                    striped
                    hover
                  ></BootstrapTable>
                </div>
                <div className="mt-2">
                  <select
                    className="form-select form-select-sm"
                    value={criteria["spatialOperator"]}
                    onChange={(e) => {
                      store.dispatch({
                        type: "cqlFilter/criteria/update",
                        payload: {
                          groupIndex: groupIndex,
                          criteriaIndex: criteriaIndex,
                          property: "spatialOperator",
                          value: e.target.value,
                        },
                      });
                    }}
                  >
                    <option value="INTERSECTS">{trans("Intersects")}</option>
                    <option value="WITHIN">{trans("Within")}</option>
                    <option value="CROSSES">{trans("Crosses")}</option>
                  </select>
                </div>
              </>
            ) : (
              ""
            )}
          </>
        );
        break;

      case "layer":
        return (
          <>
            <div className="mt-2">
              <SelectLayerDropdown
                key={key()}
                layer={criteria["layer"]}
                onChange={(e) => {
                  store.dispatch({
                    type: "cqlFilter/criteria/update",
                    payload: {
                      groupIndex: groupIndex,
                      criteriaIndex: criteriaIndex,
                      property: "layer",
                      value: e.target.value,
                    },
                  });
                }}
              ></SelectLayerDropdown>
            </div>
            <div className="mt-2">
              <SelectAttributesDropdown
                // key={key()}
                value={criteria["attribute"]}
                attributes={layers[criteria["layer"]]?.attributes}
                onChange={(e) => {
                  store.dispatch({
                    type: "cqlFilter/criteria/update",
                    payload: {
                      groupIndex: groupIndex,
                      criteriaIndex: criteriaIndex,
                      property: "attribute",
                      value: e.target.value,
                    },
                  });
                }}
              ></SelectAttributesDropdown>
            </div>
            <div className="mt-2 d-flex">
              <select
                style={{ width: "10rem" }}
                className="form-select form-select-sm form-control-sm form-control me-2"
                value={criteria["attributeOperator"]}
                onChange={(e) => {
                  store.dispatch({
                    type: "cqlFilter/criteria/update",
                    payload: {
                      groupIndex: groupIndex,
                      criteriaIndex: criteriaIndex,
                      property: "attributeOperator",
                      value: e.target.value,
                    },
                  });
                }}
              >
                <option value="=">=</option>
                <option value="like">Like</option>
                <option value=">=">&gt;=</option>
                <option value=">">&gt;</option>
                <option value="<=">&lt;=</option>
                <option value="<">&lt;</option>
              </select>
              <input
                type="text"
                className="form-control form-control-sm "
                value={criteria["attributeValue"]}
                placeholder="Type value..."
                onChange={(e) => {
                  store.dispatch({
                    type: "cqlFilter/criteria/update",
                    payload: {
                      groupIndex: groupIndex,
                      criteriaIndex: criteriaIndex,
                      property: "attributeValue",
                      value: e.target.value,
                    },
                  });
                }}
              ></input>
            </div>
            <div className="mt-2">
              <button
                className="btn btn-sm btn-secondary text-white small form-control"
                onClick={() => {
                  fetchSpatialResults(
                    criteria["layer"],
                    group,
                    criteria,
                    groupIndex,
                    criteriaIndex
                  );
                }}
              >
                <i className="fas fa-search me-2 small"></i>
                {trans("Search layer for features")}
              </button>
            </div>

            {criteria["searchData"] ? (
              <>
                <div className="mt-2">
                  <PerfectScrollbar
                    style={{ maxHeight: "15rem" }}
                    className="pe-3"
                  >
                    <FeaturesTable
                      data={criteria["searchData"]}
                      layerId={criteria["layer"]}
                      attributes={layers[criteria["layer"]]?.attributes}
                      selected={criteria["selected"]?.map((el) => {
                        return el._featureId;
                      })}
                      onSelect={(feature) => {
                        updateSelectedFeatures(
                          feature,
                          group,
                          criteria,
                          groupIndex,
                          criteriaIndex
                        );
                      }}
                    ></FeaturesTable>
                  </PerfectScrollbar>
                </div>
                <div className="mt-2">
                  <span className="small">
                    {criteria["selected"]?.length > 0
                      ? "".concat(
                          criteria["selected"].length,
                          " ",
                          trans("selected feature")
                        )
                      : trans("0 selected features")}
                  </span>
                </div>
                <div className="mt-2">
                  <select
                    className="form-select form-select-sm"
                    value={criteria["spatialOperator"]}
                    onChange={(e) => {
                      store.dispatch({
                        type: "cqlFilter/criteria/update",
                        payload: {
                          groupIndex: groupIndex,
                          criteriaIndex: criteriaIndex,
                          property: "spatialOperator",
                          value: e.target.value,
                        },
                      });
                    }}
                  >
                    <option value="INTERSECTS">{trans("Intersects")}</option>
                    <option value="WITHIN">{trans("Within")}</option>
                    <option value="CROSSES">{trans("Crosses")}</option>
                  </select>
                </div>
              </>
            ) : null}
          </>
        );

        break;

      case "favorites":
        return (
          <>
            <div className="mt-2">
              <select
                className="form-select form-select-sm"
                key={key()}
                value={criteria["layer"]}
                onChange={(e) => {
                  store.dispatch({
                    type: "cqlFilter/criteria/update",
                    payload: {
                      groupIndex: groupIndex,
                      criteriaIndex: criteriaIndex,
                      property: "layer",
                      value: e.target.value,
                    },
                  });
                  store.dispatch({
                    type: "cqlFilter/criteria/update",
                    payload: {
                      groupIndex: groupIndex,
                      criteriaIndex: criteriaIndex,
                      property: "searchData",
                      value: favorites[e.target.value],
                    },
                  });
                }}
              >
                <option value="">{trans("Select a layer")}</option>
                {Object.keys(favorites).map((favorite) => {
                  return (
                    <option value={favorite}>{layers[favorite]?.title}</option>
                  );
                })}
              </select>
            </div>
            {criteria["searchData"] ? (
              <>
                <div className="mt-2">
                  <PerfectScrollbar
                    style={{ maxHeight: "15rem" }}
                    className="pe-3"
                  >
                    <FeaturesTable
                      data={criteria["searchData"]}
                      attributes={layers[criteria["layer"]]?.attributes}
                      onSelect={(feature) => {
                        updateSelectedFeatures(
                          feature,
                          group,
                          criteria,
                          groupIndex,
                          criteriaIndex
                        );
                      }}
                    ></FeaturesTable>
                  </PerfectScrollbar>
                </div>
                <div className="mt-2">
                  <span className="small">
                    {criteria["selected"]?.length > 0
                      ? "".concat(
                          criteria["selected"].length,
                          " ",
                          trans("selected features")
                        )
                      : trans("0 selected features")}
                  </span>
                </div>
                <div className="mt-2">
                  <select
                    className="form-select form-select-sm"
                    value={criteria["spatialOperator"]}
                    onChange={(e) => {
                      store.dispatch({
                        type: "cqlFilter/criteria/update",
                        payload: {
                          groupIndex: groupIndex,
                          criteriaIndex: criteriaIndex,
                          property: "spatialOperator",
                          value: e.target.value,
                        },
                      });
                    }}
                  >
                    <option value="INTERSECTS">{trans("Intersects")}</option>
                    <option value="WITHIN">{trans("Within")}</option>
                    <option value="CROSSES">{trans("Crosses")}</option>
                  </select>
                </div>
              </>
            ) : null}
          </>
        );
        break;

      case "file":
        return (
          <>
            <div className="mt-2">
              <SelectFeaturesFromUploadFile
                selected={criteria["selected"]?.map((el) => {
                  return el._featureId;
                })}
                onSelect={(feature) => {
                  updateSelectedFeatures(
                    feature,
                    group,
                    criteria,
                    groupIndex,
                    criteriaIndex
                  );
                }}
              ></SelectFeaturesFromUploadFile>
              {criteria["selected"]?.length > 0 ? (
                <div className="mt-2">
                  <select
                    className="form-select form-select-sm"
                    value={criteria["spatialOperator"]}
                    onChange={(e) => {
                      store.dispatch({
                        type: "cqlFilter/criteria/update",
                        payload: {
                          groupIndex: groupIndex,
                          criteriaIndex: criteriaIndex,
                          property: "spatialOperator",
                          value: e.target.value,
                        },
                      });
                    }}
                  >
                    <option value="INTERSECTS">{trans("Intersects")}</option>
                    <option value="WITHIN">{trans("Within")}</option>
                    <option value="CROSSES">{trans("Crosses")}</option>
                  </select>
                </div>
              ) : (
                ""
              )}
            </div>
          </>
        );
    }
  };

  return (
    <div>
      <div className="m-3 ms-2">
        <select
          className="form-select form-select-sm "
          value={selectedLayer}
          onChange={(e) => {
            store.dispatch({
              type: "cqlFilter/layer/update",
              payload: e.target.value,
            });
          }}
        >
          <option value="">{trans("All layers")}</option>
          {Object.keys(layers)?.map((el) => {
            let layer = layers[el];

            if (layer.searchable) {
              return <option value={layer.id}>{layer.title}</option>;
            }
          })}
        </select>
      </div>
      <PerfectScrollbar
        style={{ maxHeight: "calc(100vh - 15rem)" }}
        className="p-2 pe-3"
      >
        {groups.map((group, groupIndex) => {
          return (
            <div className="card mb-3 small" key={"group".concat(groupIndex)}>
              <div className="card-header p-1">
                <div className="d-flex">
                  <div className="mt-auto mb-auto me-2 w-100 ps-2 ">
                    <strong>{"Group ".concat(groupIndex + 1)}</strong>
                  </div>
                  <div className="small me-2" style={{ width: "8rem" }}>
                    <select
                      className="form-select form-select-sm form-control-sm form-control m-0 "
                      value={group.operator}
                      onChange={(e) => {
                        store.dispatch({
                          type: "cqlFilter/criteria/update",
                          payload: {
                            groupIndex: groupIndex,
                            criteriaIndex: 0,
                            property: "operator",
                            value: e.target.value,
                          },
                        });
                      }}
                    >
                      <option value="AND">{trans("AND")}</option>
                      <option value="OR">{trans("OR")}</option>
                    </select>
                  </div>
                  <div className="mt-auto mb-auto">
                    <i
                      className="fas fa-trash-alt me-2"
                      role="button"
                      onClick={() => {
                        store.dispatch({
                          type: "cqlFilter/groups/delete",
                          payload: groupIndex,
                        });
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="card-body p-2">
                {group?.map((criteria, criteriaIndex) => {
                  let criteriaContent = null;

                  switch (criteria.type) {
                    case "attributes":
                      criteriaContent = (
                        <div>
                          <div className="mt-2">
                            <SelectAttributesDropdown
                              key={key()}
                              value={criteria["attribute"]}
                              attributes={layers[selectedLayer]?.attributes}
                              onChange={(e) => {
                                store.dispatch({
                                  type: "cqlFilter/criteria/update",
                                  payload: {
                                    groupIndex: groupIndex,
                                    criteriaIndex: criteriaIndex,
                                    property: "attribute",
                                    value: e.target.value,
                                  },
                                });
                              }}
                            ></SelectAttributesDropdown>
                          </div>
                          <div className="mt-2 d-flex">
                            <select
                              style={{ width: "10rem" }}
                              className="form-select form-select-sm form-control-sm form-control me-2"
                              value={criteria["attributeOperator"]}
                              onChange={(e) => {
                                store.dispatch({
                                  type: "cqlFilter/criteria/update",
                                  payload: {
                                    groupIndex: groupIndex,
                                    criteriaIndex: criteriaIndex,
                                    property: "attributeOperator",
                                    value: e.target.value,
                                  },
                                });
                              }}
                            >
                              <option value="=">=</option>
                              <option value="like">Like</option>
                              <option value=">=">&gt;=</option>
                              <option value=">">&gt;</option>
                              <option value="<=">&lt;=</option>
                              <option value="<">&lt;</option>
                            </select>
                            <input
                              type="text"
                              className="form-control form-control-sm "
                              value={criteria["attributeValue"]}
                              placeholder="Type value..."
                              onChange={(e) => {
                                store.dispatch({
                                  type: "cqlFilter/criteria/update",
                                  payload: {
                                    groupIndex: groupIndex,
                                    criteriaIndex: criteriaIndex,
                                    property: "attributeValue",
                                    value: e.target.value,
                                  },
                                });
                              }}
                            ></input>
                          </div>
                        </div>
                      );
                      break;

                    case "spatial":
                      criteriaContent = (
                        <div>
                          <select
                            className="form-select form-select-sm "
                            value={
                              groups[groupIndex][criteriaIndex]["spatialType"]
                            }
                            onChange={(e) => {
                              store.dispatch({
                                type: "cqlFilter/criteria/update",
                                payload: {
                                  groupIndex: groupIndex,
                                  criteriaIndex: criteriaIndex,
                                  property: "spatialType",
                                  value: e.target.value,
                                },
                              });
                            }}
                          >
                            <option value="draw">
                              {trans("Draw features")}
                            </option>
                            <option value="favorites">
                              {trans("Select features from favorites")}
                            </option>
                            <option value="layer">
                              {trans("Select features from a layer")}
                            </option>
                            <option value="file">
                              {trans("Select features from file")}
                            </option>
                          </select>
                          {spatialContent(
                            criteria,
                            group,
                            groupIndex,
                            criteriaIndex
                          )}
                        </div>
                      );
                      break;
                  }

                  return criteria.type ? (
                    <div
                      className="card  mb-3 "
                      key={"criteria".concat(
                        criteriaIndex,
                        "group",
                        groupIndex
                      )}
                    >
                      <div className="card-header p-1 ps-2 pe-2">
                        <div className="d-flex">
                          <div className="w-100">
                            {criteria.type === "spatial"
                              ? "Spatial criteria"
                              : "Attribute criteria"}
                          </div>
                          <div className="mt-auto mb-auto">
                            <i
                              className="fas fa-trash-alt me-2"
                              role="button"
                              onClick={() => {
                                store.dispatch({
                                  type: "cqlFilter/criteria/delete",
                                  payload: {
                                    groupIndex: groupIndex,
                                    criteriaIndex: criteriaIndex,
                                  },
                                });
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div className="card-body  ">{criteriaContent}</div>
                    </div>
                  ) : null;
                })}
                {group.length === 1 ? (
                  <div className="p-2 small">
                    {trans(
                      "You can add attribute or spatical criteria by clicking the appropriate button. You can also change the operator between criteria elements of the group by selecting 'AND' or 'OR' operator."
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="card-footer p-1">
                <button
                  className="btn  btn-link btn-sm small me-2"
                  onClick={() => {
                    store.dispatch({
                      type: "cqlFilter/criteria/add",
                      payload: {
                        groupIndex: groupIndex,
                        criteria: {
                          type: "spatial",
                          spatialType: "draw",
                        },
                      },
                    });
                  }}
                >
                  <span className="small">
                    <i className="fas fa-plus me-2 small"></i>
                    {trans("Add spatial criteria")}
                  </span>
                </button>
                {selectedLayer ? (
                  <button
                    className="btn  btn-link btn-sm small"
                    onClick={() => {
                      store.dispatch({
                        type: "cqlFilter/criteria/add",
                        payload: {
                          groupIndex: groupIndex,
                          criteria: {
                            type: "attributes",
                          },
                        },
                      });
                    }}
                  >
                    <span className="small">
                      <i className="fas fa-plus me-2 small"></i>
                      {trans("Add attribute criteria")}
                    </span>
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      </PerfectScrollbar>
      <div className="p-0 pe-3 text-end">
        <button
          className="btn btn-secondary btn-sm me-2"
          onClick={() => {
            store.dispatch({
              type: "cqlFilter/add",
              payload: [{ operator: "AND" }],
            });
          }}
        >
          <span className="text-white">
            <i className="fas fa-plus me-2"></i>
            {trans("Add group criteria")}
          </span>
        </button>
        {groups.length > 0 ? (
          <button
            className="btn btn-secondary btn-sm "
            onClick={async () => {
              await search();
              createNotification({
                type: "success",
                message: "Activating CQL Filtering",
              });
            }}
          >
            <span className="text-white">
              <i className="fas fa-filter me-2 "></i>
              {trans("Activate CQL")}
            </span>
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default CQLFilterPanel;
